module.exports = __webpack_public_path__ + "static/media/modele_csv_import_beneficiaires.fbd0cd45.csv";